import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatIconModule} from "@angular/material/icon";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {TextFieldModule} from "@angular/cdk/text-field";
import {NgIf} from "@angular/common";


@Component({
  selector: 'app-content-block-edit',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonToggleModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    TextFieldModule,
    NgIf
  ],
  templateUrl: './content-block-edit.component.html',
  styleUrl: './content-block-edit.component.css'
})
export class ContentBlockEditComponent implements OnInit, AfterViewInit{
  @Input() contentBlock: any;
  @Input() selectedLanguage: string = 'en';
  @Input() isEditMode: boolean = false;
  @Input() fieldToEdit: string = 'content';

  @Output() languageChange = new EventEmitter<string>();
  @Output() save = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  @ViewChild('textarea') textarea!: ElementRef;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.textarea) {
        this.textarea.nativeElement.focus();
      }
    }, 0);
  }

  changeLanguage(language: string) {
    this.languageChange.emit(language);
  }

  saveAction() {
    this.save.emit();
  }

  cancelAction() {
    this.cancel.emit();
  }

  deleteAction() {
    this.delete.emit();
  }

  onSubmit() {
    this.saveAction();
  }

}
